import { render } from "./HealthReserve.vue?vue&type=template&id=13f8327c"
import script from "./HealthReserve.vue?vue&type=script&lang=js"
export * from "./HealthReserve.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__